import React from "react";
import MicroIcon from "../brand/MicroIcon";
import { COLORS, SITE } from "../brand/tokens";

const shops = [
  {
    id: "etsy",
    name: "Etsy",
    tagline: "Handpicked lifestyle pieces",
    description: "Journals, tees, mugs, and small-batch drops. Our first storefront — soft launch collection.",
    url: SITE.shops.etsy,
    accent: COLORS.sage,
    cta: "Browse on Etsy",
    testId: "shop-etsy",
  },
  {
    id: "tapstitch",
    name: "Tapstitch",
    tagline: "Premium · Woven Tags & Labels",
    description: "Signature RW-feather woven tags on natural linen — the small luxury detail of a lifestyle brand.",
    url: SITE.shops.tapstitch,
    accent: COLORS.gold,
    cta: "Coming soon",
    testId: "shop-tapstitch",
    comingSoon: true,
  },
];

const ShopPage = () => (
  <main className="site-main site-main--cream" data-testid="page-shop">
    <section className="shop-hero">
      <p className="eyebrow">SHOP · RONA WELLNESS COLLECTIONS</p>
      <h1>Wearable calm.<br />Everyday wellness.</h1>
      <p className="lede">
        Our collections roll out gently across Etsy and Tapstitch — each piece an invitation to walk toward yourself.
      </p>
    </section>

    <section className="shop-grid">
      {shops.map((s) => (
        <article className="shop-card" key={s.id} data-testid={`shop-card-${s.id}`}>
          <div className="shop-card__accent" style={{ background: s.accent }}>
            <MicroIcon size={70} color="#fff" />
          </div>
          <div className="shop-card__body">
            <p className="eyebrow">{s.tagline}</p>
            <h3>{s.name}</h3>
            <p>{s.description}</p>
            {s.comingSoon ? (
              <span className="shop-card__soon" data-testid={`${s.testId}-soon`}>Coming soon 🌿</span>
            ) : (
              <a
                href={s.url}
                target="_blank"
                rel="noreferrer"
                className="btn btn--gold"
                data-testid={s.testId}
              >
                {s.cta} →
              </a>
            )}
          </div>
        </article>
      ))}
    </section>

    <section className="shop-note">
      <MicroIcon size={54} color={COLORS.gold} />
      <p>
        Every piece we release is thoughtfully designed and slowly produced.
        We choose <em>softness over speed</em> — because healing is not a race.
      </p>
    </section>
  </main>
);

export default ShopPage;
